<template>
  <i
    :class="`BaseIcon fi fi-br-${icon} flex flex-initial items-center justify-center`"
    @click="$emit('click')"
  />
</template>

<script>
export default {
  name: 'BaseIcon',

  props: {
    icon: { type: String, required: true }
  }
}
</script>
